"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinksToShow = exports.PlanType = void 0;
var PlanType;
(function (PlanType) {
    PlanType["DTVNOW"] = "dtvnow";
    PlanType["WIRELESS"] = "wireless";
    PlanType["DTVS"] = "dtvs";
    PlanType["IPTV"] = "iptv";
    PlanType["WIRELESS_CRP"] = "wirelessCRP";
    PlanType["BROADBAND"] = "broadband";
    PlanType["WIRELESS_PREPAID"] = "PREPAID";
    PlanType["ACCESSORIES"] = "accessories";
    PlanType["HBOMAX"] = "hbomax";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
var LinksToShow;
(function (LinksToShow) {
    LinksToShow["EDIT"] = "edit";
    LinksToShow["REMOVE"] = "remove";
})(LinksToShow = exports.LinksToShow || (exports.LinksToShow = {}));
//# sourceMappingURL=LobTitleProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LobTitle/LobTitleProps.js
// module id = 2370
// module chunks = 8